
<!--  HOME PAGE -->

<template lang="html">
  <div class="main-container">

    <section class="mobile">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <div class="masthead-logo-mobile mobile">
              <img :src="'static/img/common/logo.png'" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <mast-head
      page="home"
      >
    </mast-head>
    
    <section>
      <div class="container"> 
        <div class="row intro-box">
          <div class="col-xs-10 col-xs-offset-1 col-md-10 col-md-offset-1 text-center">
<!--             <p class="mobile" v-html="home.subtitle"></p> -->
            <h3 class="h3-subtitle" v-html="home.subtitle"></h3>
          </div>
        </div>
      </div>
    </section>

    <section>
      <my-carousel
        :array="'home_array'"
      ></my-carousel>    
    </section>

    <section>
      <div class="container"> 
        <div class="row">
          <div class="col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 text-center">
            <h2 v-html="home.about"></h2>
            <p v-for="(p, index) in home.about_body" v-html="p"></p>
            <div class="row text-center">
              <router-link class="router-link-container" to="/about"><link-button :label="home.link_button" ></link-button></router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="container">
        <div class="row text-center">

          <div class="col-lg-4 col-md-4 col-sm-4 col-md-offset-1 paragraph-left">
            <h2 v-html="home.food"></h2>
            <p v-for="(p, index) in home.food_body" v-html="p"></p>
            <router-link class="router-link-container" to="/food"><link-button :label="home.link_button" ></link-button></router-link>
          </div>
          
          <div class="col-lg-6 col-md-6 col-sm-8 box-shadow-container">
            <image-loader 
              class="image-loader-container"
              :imgSrc="'home/'+home.food_image"
              >
            </image-loader>
           
          </div>

        </div>
      </div>
    </section>

    <section>
      <div class="container">
        <div class="row text-center">

          <div class="col-lg-4 col-md-4 col-sm-4 col-md-offset-1 paragraph-left mobile">
            <h2 v-html="home.projects"></h2>
            <p v-for="(p, index) in home.projects_body" v-html="p"></p>
            <router-link class="router-link-container" to="/projects"><link-button :label="home.link_button" ></link-button></router-link>
          </div>

          <div class="col-lg-6 col-md-6 col-sm-8 col-md-offset-1 box-shadow-container">
            <image-loader 
              class="image-loader-container"
              :imgSrc="'home/'+home.projects_image"
              >
            </image-loader>
          </div>
  
          <div class="col-lg-4 col-md-4 col-sm-4 paragraph-right desktop">
            <h2 v-html="home.projects"></h2>
            <p v-for="(p, index) in home.projects_body" v-html="p"></p>
            <router-link class="router-link-container" to="/projects"><link-button :label="home.link_button"></link-button></router-link>
          </div>
          
        </div>
      </div>
    </section>

<!--     <section>
      <div class="container">
        <div class="row text-center">

          <div class="col-lg-4 col-md-4 col-sm-4 col-md-offset-1 paragraph-left">
            <h2 v-html="home.canteen"></h2>
            <p v-for="(p, index) in home.canteen_body" v-html="p"></p>
            <router-link class="router-link-container" to="/canteen"><link-button :label="home.link_button" ></link-button></router-link>
          </div>
          
          <div class="col-lg-6 col-md-6 col-sm-8 box-shadow-container">
            <image-loader 
              class="image-loader-container"
              :imgSrc="'home/'+home.canteen_image"
              >
            </image-loader>
           
          </div>

        </div>
      </div>
    </section> -->


    <!-- CLIENTS  -->
    <section class="pure-text-centered" id="clients">
      <client-section></client-section>
    </section>

    <section>
      <contact-section></contact-section>
    </section>

    <section class="section-joined-bottom">
      <text-ticker page="home"></text-ticker>
    </section>


    <section class="section-joined-top">
      <footer-image></footer-image>
    </section>
  </div>
</template>

<style >
  
</style>

<script>
import {home} from '../../content.json'
import {commontools} from '../mixins/Styling'
import MastHead from '../components/MastHead'
import MyCarousel from '../components/MyCarousel.vue'
import LinkButton from '../components/LinkButton'
import TextTicker from '../components/TextTicker'
import FooterImage from '../components/FooterImage'
import ContactSection from '../components/ContactSection'
import ClientSection from '../components/ClientSection'
import ImageLoader from '../components/ImageLoader'
import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
  observer: true,
  throttleWait: 3000,
  // optional
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.1
  },
  lazyComponent: true
})

export default {
  name: 'home',
  mixins: [commontools],
  data: function () {
    return {
      home,
      scrolly: 0,
      mymobile: '',
      myimage: '',
      loadCounter:0
    }
  },
  methods: {
    scrollToDiv (_div) {
      var top = document.getElementById(_div).offsetTop
      window.scrollTo(0, top - 43)
    }
  },
  created () {
    window.scrollTo(0, 0)
  },
  destroyed () {
  },
  mounted: function () {
    this.mastheight = window.innerHeight
    window.scrollTo(0, 0)
    setTimeout(() => {
      if (this.$route.name !== 'home') return
      if (this.$route.params.scroll !== undefined) this.scrollToDiv(this.$route.params.scroll)
      // this.manageWidows()
    }, 100)
  },
  components: {
    MastHead,
    ImageLoader,
    MyCarousel,
    FooterImage,
    LinkButton,
    ContactSection,
    ClientSection,
    TextTicker
  }
}
</script>


// WEBPACK FOOTER //
// Home.vue?08d3bbcb